import { autoinject, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { watch } from 'aurelia-watch-decorator';
import { TaskMutex } from 'framework/script_utilities/task-executor';
import { CLASS_DISABLED, CLASS_EXECUTING, CLASS_GROUP } from 'framework/html_behaviors/af-mutex-click';

@autoinject
@customElement('deviation-request-assign-to-button')
export class DeviationRequestAssignToButtonCustomElement {
  @bindable items: DeviationRequestAssignToItem[] = [];
  @bindable disabled: boolean;
  showOptions: false;
  assignToButton: HTMLButtonElement;

  constructor(private element: Element, private mutex: TaskMutex) {
  }

  attached() {
    this.showOptions = false;
    this.assignToButton.classList.add(CLASS_GROUP);
    this.assignToButton.ownerDocument.addEventListener('click', this.documentClicked)
  }

  detached() {
    this.showOptions = false;
    this.assignToButton.classList.remove(CLASS_GROUP, CLASS_EXECUTING, CLASS_DISABLED);
    this.assignToButton.ownerDocument.removeEventListener('click', this.documentClicked)
  }

  documentClicked = (e: MouseEvent) => {
    const nodeTarget = e.target as Node;
    if (nodeTarget !== null && !this.element.contains(nodeTarget) && this.showOptions)
      this.showOptions = false;
    return true;
  }

  itemClicked(item: DeviationRequestAssignToItem) {
    this.showOptions = false;
    this.mutex.executeIfNotRunning(() => this.styledClick(item));
    return false;
  }

  async styledClick(item: DeviationRequestAssignToItem) {
    try {
      this.assignToButton.classList.add(CLASS_EXECUTING);
      await item.onClick();
    }
    finally {
      this.assignToButton.classList.remove(CLASS_EXECUTING);
    }
  }

  @watch((x: DeviationRequestAssignToButtonCustomElement) => x.mutex.isRunning)
  private mutexChanged(isRunning: boolean) {
    isRunning
      ? this.assignToButton.classList.add(CLASS_DISABLED)
      : this.assignToButton.classList.remove(CLASS_DISABLED);
  }
}

export interface DeviationRequestAssignToItem {
  name: string;
  onClick(): void;
}
